/**
 * TKP-143 / tasarım s.33 md.2a-b (karar 2026-09-27): çalışma alanı paneline girince ÖNCE yöneticisi olunan çalışma alanı
 * listesi gelir; organizasyonlar / üyeler / kütüphane ekranlarına bu listeden geçilir. Eski kart panosu (`dashboard.vue`)
 * kaldırıldı, eski liste adresi `/workspace/workspaces` ana ekrana yönlenir.
 */
export const workspace = {
  routes: [
    {
      path: "/",
      component: () => import("@/modules/workspace/my-workspaces-view"),
    },
    {
      path: "workspaces",
      redirect: "/workspace",
    },
    {
      path: "edit",
      component: () => import("@/modules/workspace/workspace-form"),
    },
    // {
    //   path: "create",
    //   component: () => import("@/modules/workspace/create-workspace-view"),
    // },
    {
      path: "organizations",
      component: () => import("@/modules/workspace/workspace-organizations-view"),
    },
    {
      path: "library/import", // TKP-208: Kütüphane › Excel'den yükle (çalışma alanı sahibi / yöneticisi)
      component: () => import("@/modules/workspace/library-import/library-import-view"),
    },
    {
      path: "members",
      component: () => import("@/modules/workspace/workspace-members-view"),
    },
    {
      path: "member/:memberId",
      component: () => import("@/modules/workspace/workspace-member-info-view"),
    },
  ],
};
